import React from 'react';
import styled from 'styled-components';
import Share from '@catalogo/theme-share';
import Wishlist from '@catalogo/ui-americanas-mobile-wishlist';

const ShareAndWishlist = props => {
  const { product, currentSku } = props;
  const { name } = product || {};

  const configShare = {
    title: name,
    text: name,
  };

  return (
    <Wrapper>
      <Wishlist sku={currentSku} product={product} hasBoxShadow={false} label="favoritar" sizeButton="36px" />
      <Share {...props} hasBoxShadow={false} hasTitle={true} config={configShare} label="compartilhar" />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 2px;
  gap: 10px;
`;

export default ShareAndWishlist;
